module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "#/c006#TOC"
    }
  }, [_vm._v("Libri di Kevin Killiany")]), _c('a', {
    attrs: {
      "id": "BooksByAuthor"
    }
  })]), _c('a', {
    attrs: {
      "id": "BooksByAuthor"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "BooksByAuthor"
    }
  }, [_vm._v("TERRA E STELLE")])]), _c('a', {
    attrs: {
      "id": "BooksByAuthor"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Libro 1: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Giù per terra")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Libro 2: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("La vita a terra")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Libro 3: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Alzarsi da terra")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("(Libri in inglese)")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("MECH WARRIORS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Wolf Hunters")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("To Ride the Chimera")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("STAR TREK CORPS OF ENGINEERS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Honor")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Orphans")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("BATTLE TECH ANTHOLOGIES")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chaos Born")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chaos Formed")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Pagina dell’autore sul sito web dell’editore:")])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-decoration": "underline",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "BooksByAuthor"
    }
  }), _c('a', {
    attrs: {
      "href": "http://evolvedpub.com/team-member/author/kevin-killiany/",
      "target": "_blank"
    }
  }, [_vm._v("Kevin Killiany")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("COMMENTI A "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("GIÙ PER TERRA:")])]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("“"), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Giù per Terra ")]), _vm._v("è seria fantascienza YA con carattere, piena di dettagli tecnici e personaggi interessanti. Sono stato subito catturato dalla storia.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~ "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Kevin J. Anderson, autore bestseller")]), _vm._v(" del New York Times con Eternity’s Mind")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("“GIÙ PER TERRA [è] una lettura divertente e scorrevole... vicina alla perfezione. Tutto quello che si può desiderare in un libro YA, crescita, fantascienza, un mondo distopico, è tutto qui.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~ Readers’ Favorite Book Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "section-break-symbol",
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~~~")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("“Questa è una storia di maturazione per le ragazze, è una lotta contro il razzismo istituzionalizzato, riguarda delle ragazze che tentano di trovare i loro sogni nello spazio nero come inchiostro.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "font-weight": "bold",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("~ Jason Hansa")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0